import Axios from "axios";

export default {
  get(identification) {
    return Axios.get(
      "/fvc/getFvc?identification=" + identification
    );
  }
};